import { useEffect } from "react";
import { useImmer } from "use-immer";
import Cookies from "js-cookie";

export const useAuth = () => {
  const [auth, setAuth] = useImmer({
    isInitialLoad: true,
    data: {
      id: null,
      name: "",
      first_name: "",
      last_name: "",
      email: "",
      token: "",
      roles: [],
      permissions: [],
      selectedStoreId: null,
      stores: [],
    },
  });
  useEffect(() => {
    setAuth((draft) => {
      draft.isInitialLoad = false;
    });
    const localStorageData = JSON.parse(localStorage.getItem("pos-user-data"));
    if (localStorageData !== null) {
      setAuth((draft) => {
        draft.data = localStorageData;
      });
      Cookies.set("pos-user-data", localStorageData.token, {
        domain: window.location.hostname,
        path: "/",
        expires: 7,
        secure: true,
        sameSite: "Lax",
      });
    }
  }, []);
  useEffect(() => {
    if (auth.data.id) {
      localStorage.setItem("pos-user-data", JSON.stringify(auth.data));
      Cookies.set("pos-user-data", auth.data.token, {
        domain: window.location.hostname,
        path: "/",
        expires: 7,
        secure: true,
        sameSite: "Lax",
      });
      window.dispatchEvent(new Event("token-changed"));
    }
  }, [auth]);

  return { auth, setAuth };
};
